import { cn } from '@/lib/utils';

export type TileState = 'green' | 'yellow' | 'gray' | 'empty' | 'active';

interface TileProps {
  letter: string;
  state: TileState;
}

const stateClasses: Record<TileState, string> = {
  green: 'bg-green-600 border-green-600 text-white',
  yellow: 'bg-yellow-500 border-yellow-500 text-white',
  gray: 'bg-zinc-500 border-zinc-500 text-white',
  empty: 'border-zinc-300 dark:border-zinc-600',
  active: 'border-zinc-500 dark:border-zinc-400',
};

export function Tile({ letter, state }: TileProps) {
  return (
    <div
      className={cn(
        'w-14 h-14 border-2 flex items-center justify-center text-2xl font-bold uppercase transition-colors',
        stateClasses[state],
      )}
      data-testid="tile"
      data-state={state}
    >
      {letter}
    </div>
  );
}
